import React from "react";
import AdminPromoCodeManagement from "../../componet/admin-promo-code-management";

const PromoCodesPage: React.FC = () => {
  return <AdminPromoCodeManagement />;
};

export default PromoCodesPage;
